const initialState = {
  apps: [],
  user: { validated: false, userRoles: [] },
  documents: [],
};

export default initialState;
